var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('QuestionnairesTitle',{attrs:{"title":"Questionnaires"}})],1),(_vm.loaded)?_c('QuestionnaireAnswerForm',{attrs:{"is-project":""},on:{"refresh":_vm.fetchData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }